/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module SystemReportSummaryModule
 */

import {
    Pipe,
    PipeTransform,
} from '@angular/core';

/**
 * @description
 *     Pipe for converting a seconds to milliseconds.
 * @author Deepak Chaudhary
 */

@Pipe({
    name: 'secondToMs',
})
export class SecondToMsPipe implements PipeTransform {
    public transform(seconds: number): number {
        return seconds * 1000;
    }
}
